export default __webpack_public_path__ + "static/media/preflop-equity-handvshand_0009_thumb.4f51ac30.jpg";